module.exports = __webpack_public_path__ + "static/media/flytte.1a68c834.m4a";